import type { BrandConfig } from '@denqfabrik/landing-ui';

const brandConfig: BrandConfig = {
  name: 'Aletiq',
  siteName: 'Aletiq',
  baseUrl: 'https://aletiq.ai',
  gtm: { id: import.meta.env.VITE_GTM_ID ?? '' },

  structuredData: {
    description:
      'Aletiq is an AI agent verification platform that provides structured, reproducible test workflows for AI agents.',
    foundingLocation: 'Hannover, Germany',
    sameAs: ['https://www.linkedin.com/company/aletiq'],
    knowsAbout: [
      'AI Agent Verification',
      'Automated Testing for AI Agents',
      'Structured Test Workflows',
      'AI Safety and Quality Assurance',
      'Reproducible AI Testing',
    ],
  },
};

export default brandConfig;
